// Modules
import { AxiosRequestConfig } from "axios"

// Constants
import SESSION_KEYS from "~constants/session"

// RBAC
import { urlMapper } from "~rbac/utils/urlMapper"
import { GetRoleKeys } from "~rbac/constants/rbac-roles"
const ROLES_KEYS = GetRoleKeys()

// Utils
import { getStoredItem } from "~utils/store"
import { getMemoryToken } from "~utils/auth-token"
import { extractUserIdentity } from "~utils/user"

const rbacHttpInterceptor = (request: AxiosRequestConfig) => {
  const accessToken = getMemoryToken()
  const userCompany = getStoredItem(SESSION_KEYS.LOGGED_USER_COMPANY)

  // If we don't receive a url or the method is not the GET
  if (!request.url || request.method?.toLowerCase() !== "get") {
    return request
  }

  if (!accessToken) return request

  const loggedUser = extractUserIdentity(accessToken)

  // Get user roles
  let roles: string[] = loggedUser.authorities.roles

  // If the user do not have ROLE ADMIN, map the API url to the right one
  if (userCompany && !roles.some(role => role === ROLES_KEYS.ROLE_ADMIN)) {
    const company = JSON.parse(userCompany)
    request.url = urlMapper(request.url, company.id) || request.url
  }

  return request
}

export default rbacHttpInterceptor
